module.exports = __webpack_public_path__ + "static/media/icon_shopify.b7cc58fe.png";